// extracted by mini-css-extract-plugin
export default {"play-container":"Play_play-container__PUaKa","play":"Play_play__cX5ES"};